import Stimp from "stimp/lib/index";

export class TheListForm extends Stimp.DOMInteractModule {
  constructor(app, name, initState = {}, depends = []) {
    super(app, name, initState = {
      type: 'individual'
    }, depends);

    this.onAfterDomInit(() => {
      const radios = [...this.dom.typeSelector.querySelectorAll(`input[type="radio"][name="member_type"]`)];
      radios.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          this.setState({
            type: e.currentTarget.value,
          });
        });
      });
    });
  }

  onUpdateType(value, prevValue) {
    $(this.dom.form[value]).show();
    $(this.dom.form[prevValue]).hide();
  }
}